export default "__VITE_ASSET__931ff18b__"